import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ResourcesMobile.css';

import { resourceCards } from './resourceList';

const ResourcesMobile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="main-hero demo-hero resm-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">Research</h1>
      </section>

      <section className="resm-content">
        <div className="resm-layout">
          <p className="resm-description">
            Explore blogs, whitepapers, and case studies on AI security, governance, and compliance from the Bltz AI team.
          </p>

          <div className="resm-grid">
            {resourceCards.map((card, i) => (
              <div key={i} className="resm-card" onClick={() => { navigate(`/resources/${card.slug}`); window.scrollTo(0, 0); }}>
                <img src={card.img} alt="" className="resm-card-img" />
                <div className="resm-card-content">
                  <span className="resm-card-category">{card.category}</span>
                  <h3 className="resm-card-title">{card.title}</h3>
                  <p className="resm-card-desc">{card.desc}</p>
                  <span className="resm-card-tag">{card.tag}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="resm-cta">
            <button className="resm-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Get a Live Demo &rarr;
            </button>
          </div>

          <span className="resm-back-link" onClick={() => { navigate('/'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            ← Back to Home
          </span>
        </div>
      </section>
    </>
  );
};

export default ResourcesMobile;
